<template>
  <div class="rm-screen">
    <div v-if="loading" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>
    <div v-else-if="!rows.length" class="rm-empty">
      <v-icon size="40" color="#8a817a">mdi-account-cash-outline</v-icon>
      {{ $t("no_data") }}
    </div>

    <template v-else>
      <div class="rm-stats">
        <div v-for="(stat, index) in kpis" :key="stat.key" class="rm-stat" :class="{ 'rm-stat--accent': index === 2 }">
          <span class="rm-stat__label">{{ stat.label }}{{ stat.key === "users" ? "" : currencySuffix }}</span>
          <span class="rm-stat__value rm-num">{{ stat.value }}</span>
        </div>
      </div>

      <ul class="rm-list rm-card">
        <li v-for="row in shownRows" :key="row.key" class="gm-user">
          <button type="button" class="gm-user__btn" @click="openActions(row)">
            <span class="gm-user__text">
              <span class="gm-user__name">{{ row.name }}</span>
              <span class="gm-user__meta rm-num">{{ row.meta }}</span>
            </span>
            <span class="cmm-money rm-num" :class="{ 'is-negative': row.balance < 0 }">{{ money(row.balance) }}</span>
            <v-icon size="18" color="#8a817a">mdi-chevron-right</v-icon>
          </button>
        </li>
      </ul>
      <button v-if="hiddenCount > 0" type="button" class="rm-text-btn gm-user__more" @click="expanded = true">
        {{ $t("report_mobile.show_all_n", { n: rows.length }) }}
      </button>
    </template>

    <ui-sheet v-model="actionsSheet" :ready="Boolean(actionUser)" :label="actionUser ? actionUser.name : ''">
      <template #default>
        <h2 class="cmm-sheet__title">{{ actionUser.name }}</h2>
        <p class="rm-muted cmm-sheet__sub rm-num">
          {{ $t("credit_balance") }}{{ currencySuffix }}: {{ money(actionUser.balance) }}
        </p>
        <ul class="rm-list rm-actions">
          <li>
            <button type="button" class="rm-actions__row" @click="chooseAction('details')">
              <v-icon size="22" color="#1c1917">mdi-format-list-bulleted</v-icon>
              {{ $t("tooltip_order_details") }}
            </button>
          </li>
          <li>
            <button type="button" class="rm-actions__row" @click="chooseAction('history')">
              <v-icon size="22" color="#1c1917">mdi-history</v-icon>
              {{ $t("topup_history") }}
            </button>
          </li>
          <li>
            <button type="button" class="rm-actions__row" @click="chooseAction('topup')">
              <v-icon size="22" color="#c2410c">mdi-cash-plus</v-icon>
              {{ $t("add_credit") }}
            </button>
          </li>
        </ul>
      </template>
    </ui-sheet>

    <credit-user-details-dialog-limit-transactions
      v-model="showUserDialog"
      :user="selectedUser"
    ></credit-user-details-dialog-limit-transactions>
    <credit-user-history-dialog
      v-model="showHistoryDialog"
      :user="selectedHistoryUser"
      @navigate-to-topup="handleNavigateToTopup"
    ></credit-user-history-dialog>
  </div>
</template>

<script>
import CompanyDesktopMultiCreditUsers from "@/components/company-report/desktop/screens/multi/CompanyDesktopMultiCreditUsers.vue";
import "@/components/report/mobile/screens/group/groupMobileUsers.scss";
import hasMultiMobile from "../../hasMultiMobile";

const PAGE_SIZE = 20;

/**
 * Mobilni "Kreditni korisnici" firme "više restorana": po korisniku potrošeni kredit i stanje (crveno kad je u
 * minusu). Dodir na korisnika otvara izbor: narudžbe korisnika, istorijat dopuna ili dodavanje kredita (otvara
 * "Dodaj kredit" sa tim korisnikom). Dijalozi su isti kao u starom izveštaju. Restorani i period su u zaglavlju.
 */
export default {
  name: "CompanyMobileMultiCreditUsers",
  extends: CompanyDesktopMultiCreditUsers,
  mixins: [hasMultiMobile],
  data: () => ({
    expanded: false,
    actionsSheet: false,
    actionUser: null,
  }),
  computed: {
    shownRows() {
      const rows = this.rows.map((row) => ({
        ...row,
        meta: [
          `ID ${row.userId}`,
          ...(this.hasBranches && row.branch ? [row.branch] : []),
          `${this.$t("orders")} ${row.ordersCount}`,
          `${this.$t("spent_on_credits")} ${this.money(row.spent)}`,
        ].join(" · "),
      }));
      return this.expanded ? rows : rows.slice(0, PAGE_SIZE);
    },
    hiddenCount() {
      return this.rows.length - this.shownRows.length;
    },
  },
  methods: {
    openActions(row) {
      this.actionUser = row;
      this.actionsSheet = true;
    },
    chooseAction(action) {
      const row = this.actionUser;
      this.actionsSheet = false;
      if (!row) {
        return;
      }
      if (action === "details") {
        this.openUserDialog(row.source);
      } else if (action === "history") {
        this.openHistoryDialog(row.source);
      } else {
        this.addCredit(row.source);
      }
    },
  },
};
</script>
